import { categories } from "@/mocks/observeData";
import { SectionHeading, SectionShell } from "./common";

const iconMap: Record<string, string> = {
  food: "ri-restaurant-2-line",
  digital: "ri-cpu-line",
  beauty: "ri-sparkling-line",
  retail: "ri-shopping-bag-3-line",
  finance: "ri-bank-card-line",
  auto: "ri-car-line",
  life: "ri-store-3-line",
  internet: "ri-global-line",
};

export default function CategorySection() {
  const list = categories.filter((c) => c.id !== "all");
  return (
    <SectionShell id="category" className="bg-background-50 py-14 md:py-20">
      <SectionHeading
        eyebrow="CATEGORIES"
        title="按行业分类浏览"
        desc="不同行业的高频争议点各不相同。选择你最关心的消费领域，直达对应议题与避坑线索。"
      />

      <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {list.map((c) => (
          <a
            key={c.id}
            href="#topic"
            className="group flex flex-col rounded-lg border border-background-200 bg-background-100/70 p-5 transition-colors hover:border-accent-300 hover:bg-accent-100/40 cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50 text-primary-600 ring-1 ring-background-200 transition-colors group-hover:bg-accent-100 group-hover:text-accent-800">
                <i className={`${iconMap[c.id]} text-xl`} />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
            </div>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-primary-700 group-hover:text-accent-800">
              进入行业议题
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </a>
        ))}
      </div>
    </SectionShell>
  );
}